import React, { useState, useRef } from "react";
import Header from "../components/Header";
import { useAuth } from "../context/AuthContext";
import { Link } from "react-router-dom";
import illustration from "../assets/images/security.png";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Security() {
  const passwordRef = useRef();
  const passwordConfirmRef = useRef();
  const { currentUser, updatePassword } = useAuth();
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);

  function handleChange(e) {
    e.preventDefault();
    if (passwordRef.current.value !== passwordConfirmRef.current.value) {
      return toast.error("Passwords do not match");
    }

    const promises = [];
    setLoading(true);

    if (passwordRef.current.value) {
      promises.push(updatePassword(passwordRef.current.value));
    }

    Promise.all(promises)
      .then(() => {
        toast.success("Password updated successfully");
        passwordConfirmRef.current.value = "";
        passwordRef.current.value = "";
      })
      .catch(() => {
        toast.error("Failed to update the information");
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const handleShow = () => {
    setShow(true);
  };

  return (
    <>
      <Header />
      <div className="container mx-auto sm:py-24 sm:px-2 ">
        <div className="mt-10 sm:-mt-12">
          <div className="md:grid md:grid-cols-1 md:gap-6">
            <div className="md:col-span-1">
              <div className="px-4 sm:px-0">
                <h3 className="text-lg font-medium max-w-prose text-gray-500">
                  <Link to="/member/dashboard">Account</Link> &nbsp; &gt; &nbsp;
                  Login & Security
                </h3>
                <h3 className="text-3xl mt-4 font-bold leading-relaxed text-gray-900">
                  Login & Security
                </h3>
              </div>
            </div>
            {currentUser.providerData[0].providerId !== "google.com" ? (
              <div className="mt-5 md:mt-0 md:col-span-2">
                <form>
                  <div className="overflow-hidden sm:rounded-md">
                    <div className=" bg-white p-4 sm:p-0">
                      <div className="grid grid-row-3 gap-6">
                        <div className="col-span-6 sm:col-span-4">
                          <p className="text-xl">
                            Email -{" "}
                            <span className="font-semibold">
                              {currentUser.email}
                            </span>
                          </p>
                        </div>

                        <div className="col-span-6 sm:col-span-4">
                          <label className="block text-sm font-medium text-gray-700">
                            Password
                          </label>
                          <div class="flex bg-gray-100 p-4 w-72 space-x-4 rounded-lg mt-4">
                            <input
                              ttype="text"
                              name="name"
                              id="name"
                              placeholder="Leave blank to keep it same"
                              ref={passwordRef}
                              class="w-full bg-gray-100 outline-none"
                              onChange={handleShow}
                            />
                          </div>
                        </div>

                        <div className="col-span-6 sm:col-span-4">
                          <label className="block text-sm font-medium text-gray-700">
                            Confirm Password
                          </label>
                          <div class="flex bg-gray-100 p-4 w-72 space-x-4 rounded-lg mt-4">
                            <input
                              ttype="text"
                              name="name"
                              id="name"
                              placeholder="Leave blank to keep it same"
                              ref={passwordConfirmRef}
                              class="w-full bg-gray-100 outline-none"
                              onChange={handleShow}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    {show && (
                      <div className="px-4 py-8 text-left sm:px-0">
                        <button
                          disabled={loading}
                          type="submit"
                          className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-gradient-to-r from-blue-500 to-blue-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                          onClick={handleChange}
                        >
                          Update
                        </button>
                      </div>
                    )}
                  </div>
                </form>
              </div>
            ) : (
              <div class="container mx-auto flex px-4 sm:px-0 py-4 md:flex-row flex-col">
                <div class="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0">
                  <h1 class="title-font sm:text-4xl text-3xl mb-8 font-medium text-gray-900 pr-8">
                    Hey {currentUser.displayName}, You're loggined using your
                    <span class=""> Google account </span>
                  </h1>
                  <p className="text-xl">
                    Email -{" "}
                    <span className="font-semibold">{currentUser.email}</span>
                  </p>
                  <p className="font-semibold text-2xl py-4 mt-4">
                    Helpful links
                  </p>
                  <a
                    href="https://support.google.com/accounts/answer/41078"
                    target="_blank"
                    class="mb-8 leading-relaxed text-blue-500"
                    rel="noreferrer"
                  >
                    How to change or reset password?
                  </a>
                </div>
                <div class="lg:max-w-lg lg:w-full md:w-1/2 w-5/6 hidden lg:inline-block">
                  <img
                    class="object-cover object-center rounded h-96 ml-20"
                    alt="hero"
                    src={illustration}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}

export default Security;
